<template>
  <el-dialog
    class="gen-node-user-cert-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    top="30vh"
  >
    <el-form
      ref="editForm"
      :model="editForm"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="config-form"
    >
      <el-form-item label="节点ID" prop="NodeID">
        <el-input v-model="editForm.NodeID"></el-input>
      </el-form-item>
      <el-form-item label="节点数量" prop="CertCount">
        <el-select v-model="editForm.CertCount" placeholder="请选择节点数量" class="auto-width">
          <el-option
            v-for="item in certCountOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="加密算法" prop="PubKeyAlgorithm">
        <el-select
          v-model="editForm.PubKeyAlgorithm"
          placeholder="请选择加密算法"
          class="auto-width"
        >
          <el-option
            v-for="item in algOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleOk()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'GenNodeUserCert',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      disabled: false,
      title: '生成节点-用户证书',
      dialogVisible: false,
      editForm: {
        PubKeyAlgorithm: '',
        NodeID: '',
        CertCount: 4,
        CertType: 2
      },
      editRules: {
        NodeID: [{ required: true, message: '请填写节点ID', trigger: 'blur' }],
        CertCount: [{ required: true, message: '请选择节点数量', trigger: 'blur' }],
        PubKeyAlgorithm: [{ required: true, message: '请选择加密算法', trigger: 'blur' }]
      },
      certCountOptions: [
        { label: '4', value: 4 },
        { label: '7', value: 7 },
        { label: '10', value: 10 },
        { label: '13', value: 13 },
        { label: '16', value: 16 }
      ],
      algOptions: [
        { label: '国密', value: 0 },
        { label: 'ECDSA', value: 1 }
      ],
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  methods: {
    handleCancel() {
      this.editForm = {
        PubKeyAlgorithm: '',
        NodeID: '',
        CertCount: 4,
        CertType: 2
      }
      this.disabled = false
      this.$refs.editForm.clearValidate()
      this.dialogVisible = false
    },
    handleOpen() {
      this.dialogVisible = true
    },
    handleOk() {
      this.disabled = true
      let self = this
      this.$refs.editForm.validate(valid => {
        if (valid) {
          self.$apis.certificate
            .genDposCert(self.editForm)
            .then(res => {
              if (res?.errors == null) {
                self.$message.success('生成节点用户证书成功！')
                self.$emit('update:list')
                self.handleCancel()
              }
            })
            .catch(err => {
              self.$message.warning('生成节点用户证书失败，err:' + err.message)
              return
            })
        } else {
          self.$message.warning('请填写内容')
          self.disabled = false
          return
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.gen-node-user-cert-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
